import type React from 'react'

export type BuildWithAITheme = 'light' | 'dark'

export interface BuildWithAIStyles {
  isDark: boolean
  accent: string
  card: React.CSSProperties
  cardTitle: React.CSSProperties
  bodyText: React.CSSProperties
  /** Monospace inline-code style matching `bodyText`'s palette — for snippets inside a card. */
  code: React.CSSProperties
}

const ACCENT = '#3A8C45'

/**
 * Shared card/typography styles so a studio's own extra cards (e.g. App Studio's MCP connection
 * card) stay visually consistent with the ones rendered by `BuildWithAICore`.
 */
export function getBuildWithAiStyles(theme: BuildWithAITheme = 'dark'): BuildWithAIStyles {
  const isDark = theme === 'dark'
  return {
    isDark,
    accent: ACCENT,
    card: {
      background: isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.8)',
      border: isDark ? '1px solid rgba(58, 140, 69, 0.2)' : '1px solid #e5e7eb',
      borderRadius: '12px',
      padding: '24px',
      boxShadow: isDark ? '0 4px 6px -1px rgba(0, 0, 0, 0.3)' : '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
    },
    cardTitle: {
      fontSize: '16px',
      fontWeight: 600,
      color: isDark ? '#f8fafc' : '#111827',
      margin: 0,
      marginBottom: '12px',
    },
    bodyText: {
      fontSize: '14px',
      color: isDark ? '#94a3b8' : '#64748b',
      lineHeight: 1.7,
      margin: 0,
    },
    code: {
      fontFamily: 'monospace',
      fontSize: '13px',
      color: isDark ? '#e2e8f0' : '#1f2937',
    },
  }
}
